import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ButtonText from 'components/shared/ButtonText';
import TabIndicator from './TabIndicator';
import styles from './styles.module.scss';

function ControlledTabs(props) {
  const activeTabRef = useRef(null);

  const handleClick = (e, index) => {
    props.setActiveTabIndex(index);
  };

  return (
    <div className={classnames([styles.tabBar, { [styles.tabBarBorder]: props.border }, ...props.rowStyles])}>
      {props.tabs.map((tab, index) => {
        const active = props.activeTabIndex === index;
        return (
          <ButtonText
            muted={!active}
            onClick={e => handleClick(e, index)}
            ref={active ? activeTabRef : null}
            styles={[styles.tabButton, ...props.buttonStyles, { active, [styles.trading]: props.trading }]}
            key={tab.label}>
            {tab.label}
          </ButtonText>
        );
      })}

      {props.indicator && (
        <TabIndicator
          styles={[{ [styles.trading]: props.trading }, ...props.indicatorStyles]}
          activeTabRef={activeTabRef}
          activeTabIndex={props.activeTabIndex}
        />
      )}
    </div>
  );
}

ControlledTabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired
    })
  ),
  activeTabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  setActiveTabIndex: PropTypes.func.isRequired,
  border: PropTypes.bool,
  trading: PropTypes.bool,
  indicator: PropTypes.bool,
  rowStyles: PropTypes.array,
  buttonStyles: PropTypes.array,
  indicatorStyles: PropTypes.array
};

ControlledTabs.defaultProps = {
  tabs: [],
  border: true,
  trading: false,
  indicator: true,
  rowStyles: [],
  buttonStyles: [],
  indicatorStyles: []
};

export default ControlledTabs;
